import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({
    className = "",
    error = false,
    ...props
}, ref) => {
    return (
        <input
            ref={ref}
            className={`
        w-full bg-[#faebd7] dark:bg-[#4e342e] 
        border-2 border-[#8b4513] dark:border-[#8d6e63]
        text-wood-darker dark:text-[#f3e5f5]
        placeholder-wood-medium dark:placeholder-wood-light/50
        px-3 py-2
        outline-none
        focus:border-[#ffcc80] dark:focus:border-[#ffd54f]
        focus:shadow-[0_0_0_2px_#8b4513] dark:focus:shadow-[0_0_0_2px_#8d6e63]
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-all duration-150
        jagged-corners
        ${error ? 'border-red-500 focus:border-red-500' : ''}
        ${className}
      `}
            {...props}
        />
    );
});

Input.displayName = "Input";
